import { isAgeOver65 } from '@general/js/utils';
import { AUSTRALIAN_STATES } from '@/constants';

export const ausStates = {
  ACT: AUSTRALIAN_STATES.find((stateObj) => {
    return stateObj.display === 'ACT';
  }).returnValue.toLowerCase(),
  NSW: AUSTRALIAN_STATES.find((stateObj) => {
    return stateObj.display === 'NSW';
  }).returnValue.toLowerCase(),
  NT: AUSTRALIAN_STATES.find((stateObj) => {
    return stateObj.display === 'NT';
  }).returnValue.toLowerCase(),
  QLD: AUSTRALIAN_STATES.find((stateObj) => {
    return stateObj.display === 'QLD';
  }).returnValue.toLowerCase(),
  SA: AUSTRALIAN_STATES.find((stateObj) => {
    return stateObj.display === 'SA';
  }).returnValue.toLowerCase(),
  TAS: AUSTRALIAN_STATES.find((stateObj) => {
    return stateObj.display === 'TAS';
  }).returnValue.toLowerCase(),
  VIC: AUSTRALIAN_STATES.find((stateObj) => {
    return stateObj.display === 'VIC';
  }).returnValue.toLowerCase(),
  WA: AUSTRALIAN_STATES.find((stateObj) => {
    return stateObj.display === 'WA';
  }).returnValue.toLowerCase(),
};

/**
 * Checks whether show the Concession Card section or no.
 *
 * @param {string} addressState - The address state.
 * @param {string} DOB - Date of birth string in 'DD / MM / YYYY' format.
 * @param {boolean} extrasOnly - If card holder has extras.
 * @return {boolean} - True if met condition to show Concession Card section, or false otherwise.
 */
export const showConcessionCardSection = (addressState, DOB, extrasOnly) => {
  const state = addressState ? addressState.toLowerCase() : '';

  // "65 and Over" is 65 and above.
  const isOver65 = isAgeOver65(DOB);

  // If the residential address is in VIC/WA/NT and is under 65
  if ([ausStates.VIC, ausStates.WA, ausStates.NT].includes(state) && !isOver65) return false;

  // If the residential address is in NSW/ACT and extras only and is under 65
  if ([ausStates.NSW, ausStates.ACT].includes(state) && extrasOnly && !isOver65) return false;

  // If the residential address is in QLD/TAS/SA
  if ([ausStates.QLD, ausStates.TAS, ausStates.SA].includes(state)) return false;

  return true; // Default
};

/**
 * Checks whether show the Concession Card details or no.
 *
 * @param {string} addressState - The address state.
 * @param {string} DOB - Date of birth string in 'DD / MM / YYYY' format.
 * @param {boolean} extrasOnly - If card holder has extras.
 * @param {boolean} hasConcessionCard - If card holder has Concession Card.
 * @return {boolean} - True if met condition to show Concession Card details, or false otherwise.
 */
export const showConcessionCardDetailsForm = (addressState, DOB, extrasOnly, hasConcessionCard) => {
  // Don't display the form if user doesn't have concession card
  if (!hasConcessionCard) return false;
  if (!showConcessionCardSection(addressState, DOB, extrasOnly)) return false;

  const isOver65 = isAgeOver65(DOB);
  const state = addressState ? addressState.toLowerCase() : '';

  if ([ausStates.NSW, ausStates.ACT].includes(state)) {
    if (!extrasOnly) return true;
    if (isOver65 && extrasOnly) return false;
  }
  if ([ausStates.VIC, ausStates.NT, ausStates.WA].includes(state) && isOver65) return false;

  return false; // Default
};

/**
 * Returns a list of all concession card types able to be selected from all options types, given those already selected 
 *
 * @param {string} index - The index of the card being added
 * @param {object} selectedOptions - The currently selected concession card types
 * @param {object} allOptions - All available concession card types
 * @return {object} - A {name:value} pair of available concession options
 */
export const getSelectOptionsLeft = (index, selectedOptions, allOptions) => {
  const options = [];

  for (let i = 0; i < selectedOptions.length; i++) {
    if (i !== parseInt(index, 10)) {
      options.push(selectedOptions[i].name);
    }
  }

  return allOptions.map(({ display, returnValue }) => {
    return {
      name: display,
      value: returnValue
    };
  })
  .filter((el) => {
    return !options.includes(el.value);
  });
};